module.exports = __webpack_public_path__ + "static/media/header6.9fd3a911.png";